export function getInitials(firstName: string | null, lastName: string | null) {
    const firstInitial = firstName?.charAt(0) || '';
    const lastInitial = lastName?.charAt(0) || '';
    return (firstInitial + lastInitial).toLocaleUpperCase();
}
